import React, { useEffect } from 'react';
import Header from '../components/Header';
import Main from '../components/Main';
import Footer from '../components/Footer';
import UseChatPlus from '@/features/facility/shared/components/UseChatPlus';

const Welcome = () => {
    useEffect(() => {
      document.body.classList.add('page-home'); 
      return () => {
        document.body.classList.remove('page-home');
      };
    }, []);

  return (
    <React.Fragment>
      <Header />
      <Main />
      <Footer />
      <>{UseChatPlus()}</>
    </React.Fragment>
  );
};

export default Welcome;